import { render, staticRenderFns } from "./SBHeadingTitle.html?vue&type=template&id=6fbbfc3a&scoped=true&"
import script from "./SBHeadingTitle.ts?vue&type=script&lang=ts&"
export * from "./SBHeadingTitle.ts?vue&type=script&lang=ts&"
import style0 from "./SBHeadingTitle.css?vue&type=style&index=0&id=6fbbfc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbfc3a",
  null
  
)

export default component.exports